// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3070) return "static/chunks/8012d7e2-a39f3a0e2d885df0.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7674 ? "ca377847" : chunkId) + "." + {"823":"7168f6a01abd712f","7674":"b5309944adce5e12"}[chunkId] + ".js";
};